// extracted by css-extract-rspack-plugin
export default {"cls1":"FileUpload-cls1_ajB","cls2":"FileUpload-cls2_IVO FileUpload-cls1_ajB","compact":"FileUpload-compact_rCu"};